function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import styled, { css, ThemeContext, ThemeProvider } from 'styled-components';
import Flex from "../Grid/Flex";
import { getTypographyFontSize } from "../../theme/selectors";
import IncreaseIcon from "../Icon/IncreaseIcon";
import DecreaseIcon from "../Icon/DecreaseIcon";
import Text from "../Typography/Text";
import { calcQuantity, getIntegerString, getLocaleNumberStr, weightKGtoGR, localeStrNumberToFloat } from "./helpers";
import { keyCode } from "../../enums/keyCodeEnums";
import { CHANGE_AMOUNT_BUTTON_MINUS_TEST_ID, CHANGE_AMOUNT_BUTTON_PLUS_TEST_ID, CHANGE_AMOUNT_CONTAINER_TEST_ID, CHANGE_AMOUNT_INPUT_TEST_ID } from "./constants";
import { defaultTheme } from "./theme";
import colors from "../../colors/index";
var InputWrapper = styled(Flex).attrs({
  middle: true,
  center: true
}).withConfig({
  displayName: "QuantityControls__InputWrapper",
  componentId: "sc-17z7vd4-0"
})(["position:relative;"]);
export var ControlsWrapper = styled(Flex).attrs({
  between: true
}).withConfig({
  displayName: "QuantityControls__ControlsWrapper",
  componentId: "sc-17z7vd4-1"
})(["height:38px;position:relative;align-items:stretch;overflow:hidden;", " ", ";"], function (_ref) {
  var _theme$hover, _theme$hover2, _theme$hover3, _theme$hover4;

  var theme = _ref.theme;
  return css(["background-color:", ";border-radius:", "px;color:", ";& >:disabled{opacity:0.2;}&:after{position:absolute;left:0;right:0;top:0;bottom:0;", " border-radius:", "px;transition:300ms ease-out;pointer-events:none;content:'';}&:hover{background-color:", ";color:", ";&:after{", "}}transition:300ms ease-out;"], theme === null || theme === void 0 ? void 0 : theme.bgColor, theme.borderRadius, theme === null || theme === void 0 ? void 0 : theme.color, (theme === null || theme === void 0 ? void 0 : theme.borderColor) && "border: 1px solid ".concat(theme === null || theme === void 0 ? void 0 : theme.borderColor, ";"), theme === null || theme === void 0 ? void 0 : theme.borderRadius, theme === null || theme === void 0 ? void 0 : (_theme$hover = theme.hover) === null || _theme$hover === void 0 ? void 0 : _theme$hover.bgColor, theme === null || theme === void 0 ? void 0 : (_theme$hover2 = theme.hover) === null || _theme$hover2 === void 0 ? void 0 : _theme$hover2.color, (theme === null || theme === void 0 ? void 0 : (_theme$hover3 = theme.hover) === null || _theme$hover3 === void 0 ? void 0 : _theme$hover3.borderColor) && "border: 1px solid ".concat(theme === null || theme === void 0 ? void 0 : (_theme$hover4 = theme.hover) === null || _theme$hover4 === void 0 ? void 0 : _theme$hover4.borderColor, ";"));
}, function (_ref2) {
  var isKomus = _ref2.isKomus;

  if (isKomus) {
    return css(["caret-color:", " !important;background-color:", " !important;border-color:", ";color:", ";font-size:16px;line-height:24px;font-weight:500;&:after{border:none;}&:focus,&:hover{&:after{border:1px solid ", " !important;}}"], colors.primaryMain, colors.light200, colors.light200, colors.dark300, colors.primaryAction);
  }
});
var QuantityInput = styled.input.withConfig({
  displayName: "QuantityControls__QuantityInput",
  componentId: "sc-17z7vd4-2"
})(["position:absolute;left:0;right:0;max-width:60px;z-index:1;background:none;text-align:left;border:none;box-sizing:border-box;outline:none;padding:0;", " color:transparent;", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return css(["caret-color:", ";font-family:", ";font-weight:", ";", ";"], theme === null || theme === void 0 ? void 0 : theme.color, theme === null || theme === void 0 ? void 0 : theme.fontFamily, theme === null || theme === void 0 ? void 0 : theme.fontWeight, getTypographyFontSize(theme === null || theme === void 0 ? void 0 : theme.fontSize));
}, function (_ref4) {
  var isKomus = _ref4.isKomus;

  if (isKomus) {
    return css(["caret-color:", " !important;background-color:", " !important;border-color:", " !important;color:", " !important;font-size:16px !important;line-height:24px !important;font-weight:500 !important;"], colors.primaryMain, colors.light200, colors.light200, colors.dark300);
  }
});
var QuantityValue = styled(Text).attrs(function (_ref5) {
  var theme = _ref5.theme;
  return {
    size: theme === null || theme === void 0 ? void 0 : theme.fontSize,
    fontFamily: theme === null || theme === void 0 ? void 0 : theme.fontFamily,
    fontWeight: theme === null || theme === void 0 ? void 0 : theme.fontWeight,
    center: true
  };
}).withConfig({
  displayName: "QuantityControls__QuantityValue",
  componentId: "sc-17z7vd4-3"
})(["display:block;text-align:center;", ";"], function (_ref6) {
  var isKomus = _ref6.isKomus;

  if (isKomus) {
    return css(["color:", ";font-size:16px;line-height:24px;font-weight:500;"], colors.dark300);
  }
});
export var QuantityButton = styled.button.withConfig({
  displayName: "QuantityControls__QuantityButton",
  componentId: "sc-17z7vd4-4"
})(["display:flex;justify-content:center;align-items:center;height:100%;width:auto;aspect-ratio:1/1;cursor:pointer;background-color:transparent;color:inherit;border:unset;padding:0;", ";"], function (_ref7) {
  var isKomus = _ref7.isKomus;

  if (isKomus) {
    return css(["background-color:", ";"], colors.light200);
  }
});
var StyledDecreaseIcon = styled(DecreaseIcon).withConfig({
  displayName: "QuantityControls__StyledDecreaseIcon",
  componentId: "sc-17z7vd4-5"
})(["", ";"], function (_ref8) {
  var isKomus = _ref8.isKomus;

  if (isKomus) {
    return css(["color:", ";"], colors.primaryMain);
  }
});
var StyledIncreaseIcon = styled(IncreaseIcon).withConfig({
  displayName: "QuantityControls__StyledIncreaseIcon",
  componentId: "sc-17z7vd4-6"
})(["", ";"], function (_ref9) {
  var isKomus = _ref9.isKomus;

  if (isKomus) {
    return css(["color:", ";"], colors.primaryMain);
  }
});

var QuantityControls = function QuantityControls(_ref10) {
  var onChange = _ref10.onChange,
      _ref10$quantity = _ref10.quantity,
      quantity = _ref10$quantity === void 0 ? 0 : _ref10$quantity,
      weight = _ref10.weight,
      _ref10$showWeight = _ref10.showWeight,
      showWeight = _ref10$showWeight === void 0 ? false : _ref10$showWeight,
      className = _ref10.className,
      _ref10$isAmountOverLi = _ref10.isAmountOverLimit,
      isAmountOverLimit = _ref10$isAmountOverLi === void 0 ? false : _ref10$isAmountOverLi,
      _ref10$minQuantity = _ref10.minQuantity,
      minQuantity = _ref10$minQuantity === void 0 ? 0 : _ref10$minQuantity,
      isKomus = _ref10.isKomus;
  var resultQuantity = useMemo(function () {
    return quantity < minQuantity ? minQuantity : quantity;
  }, [quantity, minQuantity]);

  var _useState = useState(calcQuantity(resultQuantity, weight, showWeight)),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setValue = _useState2[1];

  var inputRef = useRef(null);

  var _useContext = useContext(ThemeContext),
      quantityContextTheme = _useContext.quantity;

  var resultTheme = _objectSpread({}, defaultTheme, {}, quantityContextTheme);

  useEffect(function () {
    setValue(calcQuantity(resultQuantity, weight, showWeight));
  }, [resultQuantity, showWeight, weight]);

  var handleChange = function handleChange(e) {
    e.preventDefault();
    var value = e.target.value;
    var rawNumericValue = localeStrNumberToFloat(value);

    if (Number.isNaN(rawNumericValue) || rawNumericValue < minQuantity) {
      return;
    }

    var formattedValue = showWeight ? getLocaleNumberStr(value) : getIntegerString(value);
    setValue(formattedValue);
  };

  var handleFocus = function handleFocus() {
    var _inputRef$current;

    // eslint-disable-next-line no-unused-expressions
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.select();
  };

  var submitValue = function submitValue() {
    var numericValue = localeStrNumberToFloat(inputValue);
    var resultQuantity = showWeight ? weightKGtoGR(numericValue) / weight : numericValue;
    onChange(resultQuantity, showWeight ? numericValue : undefined);
  };

  var handleChangeAmount = function handleChangeAmount(nextQuantity) {
    var safeNextQuantity = nextQuantity < minQuantity ? minQuantity : nextQuantity;
    onChange(safeNextQuantity, showWeight ? safeNextQuantity * weight : undefined);
  };

  var handleIncrease = function handleIncrease() {
    var nextQuantity = quantity + 1;
    handleChangeAmount(nextQuantity);
  };

  var handleDecrease = function handleDecrease() {
    var nextQuantity = quantity - 1;
    handleChangeAmount(nextQuantity);
  };

  var handleKeyDown = function handleKeyDown(e) {
    var _inputRef$current2;

    // eslint-disable-next-line default-case
    switch (e.key) {
      case keyCode.Enter:
        // eslint-disable-next-line no-unused-expressions
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.blur();
        submitValue();
        break;

      case keyCode.Up:
        handleIncrease();
        break;

      case keyCode.Down:
        handleDecrease();
    }
  };

  return React.createElement(ThemeProvider, {
    theme: resultTheme
  }, React.createElement(ControlsWrapper, {
    "data-testid": CHANGE_AMOUNT_CONTAINER_TEST_ID,
    className: className,
    isKomus: isKomus
  }, React.createElement(QuantityButton, {
    "data-testid": CHANGE_AMOUNT_BUTTON_MINUS_TEST_ID,
    disabled: quantity === minQuantity,
    onClick: handleDecrease,
    isKomus: isKomus
  }, React.createElement(StyledDecreaseIcon, {
    color: isAmountOverLimit ? colors.silverChalice : 'currentColor',
    isKomus: isKomus
  })), React.createElement(InputWrapper, null, React.createElement(QuantityInput, {
    "data-testid": CHANGE_AMOUNT_INPUT_TEST_ID,
    ref: inputRef,
    onFocus: handleFocus,
    onBlur: submitValue,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    value: inputValue,
    showWeight: showWeight,
    maxLength: showWeight ? 5 : 4,
    isKomus: isKomus
  }), React.createElement(QuantityValue, {
    isKomus: isKomus
  }, inputValue, showWeight && React.createElement(Text, {
    size: 200,
    fontWeight: (resultTheme === null || resultTheme === void 0 ? void 0 : resultTheme.fontWeightUnit) || '400'
  }, "\xA0\u043A\u0433"))), React.createElement(QuantityButton, {
    "data-testid": CHANGE_AMOUNT_BUTTON_PLUS_TEST_ID,
    onClick: handleIncrease,
    disabled: isAmountOverLimit,
    isKomus: isKomus
  }, React.createElement(StyledIncreaseIcon, {
    color: "currentColor",
    isKomus: isKomus
  }))));
};

export default QuantityControls;